import React from 'react';
import { getPackages } from '../../../api';

export const LiveTableContext = React.createContext({});

export function TableLiveContextProvider({children}) {

    const [data, setData] = React.useState([]);
    const [accessed, setAccessed] = React.useState(false);
    const [filters, setFilters] = React.useState({});
    const [page, setPage] = React.useState(0);
    const [pageSize, setPageSize] = React.useState(10);
    const [count, setCount] = React.useState(10);
    const [livePackage, setlivePackage] = React.useState(true);

    const addFilter = (filterKey, value) => {
        setFilters((previousFilters) => {return {...previousFilters, [filterKey]:value}})
    };

    const deleteFilter = (key) => {
        setFilters((previousFilters) => {
            delete previousFilters[key];
            return {...previousFilters}
        })
    };

    React.useEffect(() => {
        if (accessed){
            getPackages({pageSize, page, livePackage, ...filters}).then((response) => {
                setData((response.packages || []).map(_package => _package.info));
                setCount(response.totalSize)
            })
        }
    }, [filters, pageSize, page, livePackage, accessed]);


    return (<LiveTableContext.Provider value={{
        data,
        filters,
        addFilter: addFilter,
        deleteFilter: deleteFilter,
        page,
        setPage,
        pageSize,
        setPageSize,
        count,
        livePackage,
        setlivePackage,
        setAccessed
    }}>
        {children}
    </LiveTableContext.Provider>)
}